import { Intent } from 'signup-constants/Intent';
import { getFlowConfig } from '../../flow-initial/getFlowConfig';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getIntentKey } from '../../routing/getIntentKey';
import { Step } from '../../views/Step';
export const BranchMarketingMicroapps = {
  name: 'BranchMarketingMicroapps',
  stateCheck: () => {
    return getIntentKey() === Intent.campaignAssistant || getIntentKey() === Intent.blogIdeasGenerator;
  },
  rebuildFlow: (flow, state, dispatch) => {
    if (getIntentKey() === Intent.campaignAssistant) {
      getFlowConfig().shouldHalveProgressBar = true;
    }

    return dispatch(FlowStateManager.removeSteps([Step.CrmExperienceLevel]));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};